import { render, staticRenderFns } from "./ManageScheduleItemPrograms.vue?vue&type=template&id=61e8522d&scoped=true&"
import script from "./ManageScheduleItemPrograms.vue?vue&type=script&lang=js&"
export * from "./ManageScheduleItemPrograms.vue?vue&type=script&lang=js&"
import style0 from "./ManageScheduleItemPrograms.vue?vue&type=style&index=0&id=61e8522d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e8522d",
  null
  
)

export default component.exports